module.exports = __webpack_public_path__ + "easeInBottom.gif";